<template>
  <div>
      LAB
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
